import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import AppInput from '../../../../common/AppInput';
import MotiveTitle from '../../../Contact/Motive/MotiveTitle';
import { useProblemsGiftcard } from './styles';
import { textMapper } from '../../../../../helpers/FormHelper';
import { COMPLETE_FORM } from '../../../../../constants/texts';

const Form = ({ ...props }) => {
  const { state, onData, mobile, motiveId, fields } = props;
  const classes = useProblemsGiftcard({ mobile });

  const handleChange = (e) => {
    onData({ name: e.target.name, value: e.target.value });
  };

  return (
    <React.Fragment>
      <MotiveTitle
        icon={textMapper.get(motiveId).icon}
        title={textMapper.get(motiveId).title}
        subtitle={textMapper.get(motiveId).subtitle}
        mobile={mobile}
      />

      <Typography className={classes.title}>{COMPLETE_FORM}</Typography>

      {fields.map((field, index) => (
        <React.Fragment key={index}>
          {!field.hidden && (
            <AppInput
              onChange={handleChange}
              onBlur={() => {}}
              onClick={() => {}}
              disabled={state[field.name]?.disabled || false}
              name={field.name}
              error={state[field.name]?.error || false}
              type={state[field.name]?.type || ''}
              label={state[field.name]?.label || ''}
              required={state[field.name]?.required || false}
              inputAdornment={state[field.name]?.inputAdornment || ''}
              success={state[field.name]?.success || ''}
              helperText={state[field.name]?.helper || ''}
              multiline={state[field.name]?.multiline || false}
              rows={state[field.name]?.rows || ''}
              value={state[field.name]?.value || ''}
              errorMessage={state[field.name]?.message || ''}
            />
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

Form.propTypes = {
  state: PropTypes.object,
  onData: PropTypes.func,
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  fields: PropTypes.array,
};

export default Form;
